import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { ActionMenuComponent } from '../../../../shared/components/action-menu/action-menu.component';
import { VideoModalComponent } from '../../../../shared/components/video-modal/video-modal.component';
import { StorageKeys, UserRoles } from '../../../../shared/enums/enums';
import { VideoModel } from '../../../../shared/models/video.model';
import { StorageService } from '../../../../shared/services/storage.service';
import { SharedModule } from '../../../../shared/shared.module';

@Component({
  selector: 'app-video-card',
  standalone: true,
  templateUrl: './video-card.component.html',
  styleUrl: './video-card.component.scss',
  imports: [ActionMenuComponent, VideoModalComponent, SharedModule],
})
export class VideoCardComponent implements OnInit {
  @Input() videoData: VideoModel | null = null;
  @Input() isMenuOpen: boolean = false;
  @Input() lastElement: boolean = false;
  @Output() openMenuEmitter: EventEmitter<void> = new EventEmitter();
  @Output() closeMenuEmitter: EventEmitter<void> = new EventEmitter();
  @Output() onDeleteVideoEmitter: EventEmitter<string> = new EventEmitter();
  @Output() loadMoreIfLastIndexEmitter: EventEmitter<void> = new EventEmitter();
  @Output() videoPlay: EventEmitter<void> = new EventEmitter();
  showMenu = false;
  showFallBackImage = false;

  constructor(private router: Router, private storageService: StorageService) {}
  ngOnInit(): void {
    this.showMenu =
      this.storageService.getItem(StorageKeys.userRole) === UserRoles.ADMIN;
  }

  openMenu() {
    this.openMenuEmitter.emit();
  }

  closeAllMenu() {
    this.closeMenuEmitter.emit();
  }

  handleEditBlog(id: string | number) {
    this.router.navigate(['/edit-video/' + id]);
  }

  loadMoreIfLastIndex() {
    this.loadMoreIfLastIndexEmitter.emit();
  }

  handleErrorOnImage(e: any) {
    this.showFallBackImage = true;
  }
}
